module.exports = __webpack_public_path__ + "media/fonts/Oricons-ed8629cbaf4f3daf579d3697566cb906.eot";